<template>
  <user-layout>
    <transition enter-active-class="animated fadeIn">
      <b-row class="h-100">
        <b-colxx xxs="12" md="10" class="mx-auto my-auto">
          <b-card class="auth-card" no-body>
            <div class="position-relative image-side d-flex flex-column">
              <div class="mt-auto">
                <p class="h2 mb-3">سامانه شهید باقری</p>
                <p class="white mb-0">
                  پایگاه جامع اطلاعات نیرویی اتحادیه انجمن‌های اسلامی
                  دانش‌آموزان
                </p>
              </div>
            </div>
            <div class="form-side py-4">
              <router-link tag="a" to="/">
                <img
                  src="../../assets/logos/logo-dark.png"
                  class="my-4"
                  style="height: 120px"
                />
              </router-link>
              <h6 class="my-4">ورود به سامانه</h6>

              <b-form
                autocomplete="off"
                @submit.prevent="formSubmit"
                class="av-tooltip tooltip-label-bottom"
              >
                <b-form-group label="شناسه کاربری" class="has-float-label mb-4">
                  <b-form-input
                    type="text"
                    v-model="$v.username.$model"
                    :state="!$v.username.$error"
                    dir="ltr"
                    class="text-left"
                    ref="username"
                  />
                  <b-form-invalid-feedback v-if="!$v.username.required"
                    >لطفا نام کاربری را وارد کنید</b-form-invalid-feedback
                  >
                  <b-form-invalid-feedback v-else-if="!$v.username.minLength"
                    >حداقل 5 حرف</b-form-invalid-feedback
                  >
                </b-form-group>

                <b-form-group label="رمز عبور" class="has-float-label mb-4">
                  <b-form-input
                    type="password"
                    v-model="$v.password.$model"
                    :state="!$v.password.$error"
                    dir="ltr"
                    class="text-left"
                  />
                  <b-form-invalid-feedback v-if="!$v.password.required"
                    >رمز عبور را وارد کنید</b-form-invalid-feedback
                  >
                  <b-form-invalid-feedback v-else-if="!$v.password.minLength"
                    >حداقل 5 حرف</b-form-invalid-feedback
                  >
                </b-form-group>
                <div class="d-flex justify-content-between align-items-center">
                  <router-link tag="a" class="text-danger" to="/forgot-password"
                    >رمزم را فراموش کرده‌ام</router-link
                  >
                  <b-button
                    type="submit"
                    variant="primary"
                    size="lg"
                    :disabled="processing"
                    :class="{
                      'btn-multiple-state btn-shadow': true,
                      'show-spinner': processing,
                    }"
                  >
                    <span class="spinner d-inline-block">
                      <span class="bounce1"></span>
                      <span class="bounce2"></span>
                      <span class="bounce3"></span>
                    </span>
                    <span class="icon success">
                      <i class="simple-icon-check"></i>
                    </span>
                    <span class="icon fail">
                      <i class="simple-icon-exclamation"></i>
                    </span>
                    <span class="label">ورود</span>
                  </b-button>
                </div>
              </b-form>
              <hr />
              <div class="text-center">
                <router-link to="/graduate">
                  <b-btn class="mt-5" variant="warning"
                    >ورود فارغ‌التحصیلان</b-btn
                  >
                </router-link>
              </div>
            </div>
          </b-card>
        </b-colxx>
      </b-row>
    </transition>
  </user-layout>
</template>

<script>
import axios from "axios";
import router from "../../router/router.js";
import { validationMixin } from "vuelidate";
const { required, minLength } = require("vuelidate/lib/validators");
import UserLayout from "../../layouts/UserLayout";

export default {
  components: { "user-layout": UserLayout },
  data() {
    return {
      username: "",
      password: "",
      processing: false,
    };
  },
  mixins: [validationMixin],
  validations: {
    username: { required, minLength: minLength(5) },
    password: { required, minLength: minLength(5) },
  },
  methods: {
    formSubmit() {
      if (this.username.length < 5) {
        this.$notify(
          "error",
          "شناسه کاربری",
          "لطفا شناسه کاربری خود را وارد کنید"
        );
        return;
      }
      if (this.password.length < 5) {
        this.$notify("error", "رمز عبور", "لطفا رمز عبور خود را وارد کنید");
        return;
      }
      if (!this.$v.$anyError) {
        this.processing = true;
        axios
          .post("login/", {
            username: this.toEnglish(this.username),
            password: this.toEnglish(this.password),
            prefix: "b",
          })
          .then((res) => {
            this.$cookie.set("userToken", res.data.token);
            axios
              .get("b/org/get-user/", {
                headers: { Authorization: "token " + res.data.token },
              })
              .then((res) => {
                this.$store.dispatch("setCurrentUser", res.data);
                axios
                  .get("b/org/get-summery/", {
                    params: { slug: res.data.slug },
                  })
                  .then((res) => this.$store.commit("setSummery", res.data));
                router.push("/");
                this.$notify("success", "خوشامد!", "ورود موفق به سامانه");
              })
              .catch(() =>
                this.$notify("error", "ورود ناموفق", "لطفا دوباره تلاش کنید")
              )
              .finally(() => (this.processing = false));
          })
          .catch((er) => {
            if (er.response.data === "not allowed")
              this.$notify(
                "error",
                "غیرمجاز",
                "شما مجاز به ورود به سامانه شهید باقری نیستید"
              );
            else
              this.$notify("error", "ورود ناموفق", "شناسه یا رمز عبور غلط است");
            this.processing = false;
          });
      }
    },
    toEnglish(val) {
      return val
        .replace(/۱/g, 1)
        .replace(/۲/g, 2)
        .replace(/۳/g, 3)
        .replace(/۴/g, 4)
        .replace(/۵/g, 5)
        .replace(/۶/g, 6)
        .replace(/۷/g, 7)
        .replace(/۸/g, 8)
        .replace(/۹/g, 9)
        .replace(/۰/g, 0);
    },
  },
  mounted() {
    if (this.$cookie.get("userToken")) this.$router.push("/");
    this.$nextTick(() => this.$refs.username.focus());
  },
};
</script>
